var apiParty = {

    fetchOrganizations() {
        console.log("fetchOrganizations(): fetching via. AJAX");
        return $.getJSON('/party/organizations');
    },
};

module.exports = apiParty;